export default {"src":"/_next/static/media/family.6cb31474.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};